import React from 'react'
import styles from './index.module.scss'
import { useHistory } from 'react-router-dom'

export default function NotMatch() {
  let history = useHistory()

  return (
    <div className={styles.page404}>
      <h1 className={styles.title}>你要找的页面似乎不见了</h1>
      <div className={styles.optContainer}>
        <button className={styles.btn} onClick={() => history.goBack()}>
          回到上一页
        </button>
      </div>
    </div>
  )
}
